import { Component, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';
import { ParplatzData } from '../../providers/pp-data';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

@Component({
  selector: 'pp-detail',
  templateUrl: 'pp-detail.html'
})
export class PPDetailPage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";
  viewmode = "info";
  kontrollinfoConent : string;
  kontrinfourl  : string;
  bLoading : boolean;
  oSelectedPP;
  ppstatus;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            , private ppData: ParplatzData
            //, private sanitizer: DomSanitizer
            
            ) {
    //let selectedpp = navParams.get('pp');
    this.bLoading = false;
    
    
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedPP = navParams.data;
    this.init();
    
    Promise.all([    
        this.ppData.ppstatus(this.oSelectedPP.grundid),            
      ]).then(data => {
        //console.log(data);
        this.ppstatus = this.ppData.ppstatusdata;      
      });    
    //console.log(this.oSelectedPP);

   }
  doRefresh(refresh){
        Promise.all([
            this.ppData.ppstatus(this.oSelectedPP.grundid),            
          ]).then(data => {
            //console.log(data);
            this.ppstatus = this.ppData.ppstatusdata;      
            refresh.complete();     
          });    
    
  }  
   init(){
   }


  
}



// WEBPACK FOOTER //
// ./src/pages/pp-list/pp-detail.ts